import {useNavigate, useParams} from 'react-router-dom'
import React, {useEffect, useState} from 'react'
import {Paper} from '@mui/material'
import './ItemListDetail.scss'
import {useCurrentGuildContext, useDatxPathGenerator} from '../../util/routing'
import {ROUTES} from '../../constants/routing'
import {useGetItemListQuery} from '../rtkItemListApi'
import {
    SearchResultTableForItemList
} from '../../search/searchResultPage/components/SearchResultTable/SearchResultTableForItemList'
import {useFullSearch} from '../../search/searchResultPage/useFullSearch'
import {ItemRetrieveType} from '../../search/model/SearchFilter'

export const ItemListDetail = () => {
    const navigate = useNavigate()
    const generatePath = useDatxPathGenerator()
    const {itemListId} = useParams()
    const [currentGuildContext] = useCurrentGuildContext()

    const {data: currentList = null, isFetching} = useGetItemListQuery(
        {
            listId: itemListId
        },
        {skip: !currentGuildContext}
    )

    const fullSearchResult = useFullSearch({
        useFilters: true,
        overrideSearch: {
            options: {
                itemRetrieveType: ItemRetrieveType.SUMMARY
            }
        }
    })

    const [previousGuildContext, setPreviousGuildContext] = useState(currentGuildContext)
    useEffect(() => {
        if (previousGuildContext && previousGuildContext.guildId !== currentGuildContext?.guildId) {
            navigate(generatePath(ROUTES.manageItemLists.path))
        }
        setPreviousGuildContext(currentGuildContext)
    }, [currentGuildContext])

    return (
        <div>
            {!isFetching && <Paper>
                <div className="item-list-title">{currentList?.name ?? '-'}</div>
            </Paper>}
            <SearchResultTableForItemList
                currentList={currentList}
                fullSearchResult={fullSearchResult}
            />
        </div>
    )
}